import { c as _c } from "react/compiler-runtime";
import { IconWorld } from "@tabler/icons-react";
import { useMemo } from "react";
import { DnsGroup } from "@/components/domain/dns/dns-group";
import { DnsRecordList } from "@/components/domain/dns/dns-record-list";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
import type { DnsRecord, DnsRecordsResponse } from "@domainstack/types";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@domainstack/ui/empty";
export function DnsSection(t0) {
  const $ = _c(5);
  const {
    data
  } = t0;
  const records = data?.records;
  let byType;
  if ($[0] !== records) {
    byType = {
      A: [],
      AAAA: [],
      MX: [],
      TXT: [],
      NS: []
    };
    for (const r of records ?? []) {
      if (r.value !== "") {
        byType[r.type].push(r);
      }
    }
    $[0] = records;
    $[1] = byType;
  } else {
    byType = $[1];
  }
  const recordsByType = byType;
  let t1;
  if ($[2] !== records || $[3] !== recordsByType) {
    t1 = <ReportSection {...sections.dns}>{records && records.length > 0 ? <div className="space-y-4"><DnsGroup title="A Records" color="blue" count={recordsByType.A.length}><DnsRecordList records={recordsByType.A} type="A" /></DnsGroup><DnsGroup title="AAAA Records" color="cyan" count={recordsByType.AAAA.length}><DnsRecordList records={recordsByType.AAAA} type="AAAA" /></DnsGroup><DnsGroup title="MX Records" color="green" count={recordsByType.MX.length}><DnsRecordList records={recordsByType.MX} type="MX" /></DnsGroup><DnsGroup title="TXT Records" color="orange" count={recordsByType.TXT.length}><DnsRecordList records={recordsByType.TXT} type="TXT" /></DnsGroup><DnsGroup title="NS Records" color="purple" count={recordsByType.NS.length}><DnsRecordList records={recordsByType.NS} type="NS" /></DnsGroup></div> : <Empty className="border border-dashed"><EmptyHeader><EmptyMedia variant="icon"><IconWorld /></EmptyMedia><EmptyTitle>No DNS records found</EmptyTitle><EmptyDescription>We couldn't resolve A/AAAA, MX, TXT, or NS records for this domain. If DNS was recently updated, it may take time to propagate.</EmptyDescription></EmptyHeader></Empty>}</ReportSection>;
    $[2] = records;
    $[3] = recordsByType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}